import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
var ls = new SecureLS({
  isCompression: false,
  encryptionSecret: process.env.VUE_APP_STORAGE_ENCRYPTION_KEY || 'fahsy-dashboard-secure-key-v1',
});

import modules from './modules';

const store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({
      key: 'auth_user', // Change this key as needed
      paths: ['authUser'], // Array of module names to persist
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});

export default store;
